// ./src/hooks/useOfferCountdown.ts
//
// ROADMAP #60 (MONETIZATION §7.6) — the in-session upgrade offer's countdown. It counts down from the SERVER's seconds left
// (`upgradeOffer.secondsLeft`, `offerSecondsLeft`), measuring only the time that passes here — never from the browser's
// clock against an end time, so a wrong device clock cannot show a window that is already closed (or hide an open one).
// ⚠ Not `useElapsedTime`: that counts UP from a timestamp on the browser's clock.
// ⓘ A new answer from the server (a reload) restarts it from the new number; at 0 it stops.
import { useEffect, useState } from "react";

/** Whole seconds left, ticking once a second; 0 when there is no offer or it has run out. */
export const useOfferCountdown = (secondsLeft: number | null | undefined): number => {
  const total = Math.max(0, Math.floor(Number(secondsLeft) || 0));
  const [left, setLeft] = useState(total);

  useEffect(() => {
    setLeft(total);

    if (total <= 0) {
      return;
    }

    const started = performance.now();
    const timer = window.setInterval(() => {
      const next = Math.max(0, total - Math.floor((performance.now() - started) / 1000));

      setLeft(next);

      if (next === 0) {
        window.clearInterval(timer);
      }
    }, 1000);

    return () => window.clearInterval(timer);
  }, [total]);

  return left;
};

/** "42:07" — minutes and seconds (the window is an hour at most). */
export const formatOfferCountdown = (seconds: number): string => {
  const s = Math.max(0, Math.floor(seconds));

  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`;
};
